"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierContactsProfileFields = void 0;
exports.SupplierContactsProfileFields = [
    'companyName',
    'description',
    'logo',
    'website',
    'facebook',
    'instagram',
    'contactEmail',
    'contactPhoneNumber',
];
//# sourceMappingURL=SupplierProfile.js.map